var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 0C8.6485 0 0 8.6485 0 49C0 89.3515 8.6485 98 49 98C89.3515 98 98 89.3515 98 49C98 8.6485 89.3515 0 49 0ZM49 10C16.8835 10 10 16.8835 10 49C10 81.1165 16.8835 88 49 88C81.1165 88 88 81.1165 88 49C88 16.8835 81.1165 10 49 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49C10 16.8835 16.8835 10 49 10C81.1165 10 88 16.8835 88 49C88 81.1165 81.1165 88 49 88C16.8835 88 10 81.1165 10 49Z",
    fill: "url(#pattern0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49C10 16.8835 16.8835 10 49 10C81.1165 10 88 16.8835 88 49C88 81.1165 81.1165 88 49 88C16.8835 88 10 81.1165 10 49Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 49C10 16.8835 16.8835 10 49 10C81.1165 10 88 16.8835 88 49C88 81.1165 81.1165 88 49 88C16.8835 88 10 81.1165 10 49Z",
    fill: "#FB6F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1 49C1 38.9349 1.54061 30.9151 2.958 24.5374C4.37287 18.1711 6.64806 13.5025 10.0753 10.0753C13.5025 6.64806 18.1711 4.37287 24.5374 2.958C30.9151 1.54061 38.9349 1 49 1C59.0651 1 67.0849 1.54061 73.4626 2.958C79.8289 4.37287 84.4975 6.64806 87.9247 10.0753C91.3519 13.5025 93.6271 18.1711 95.042 24.5374C96.4594 30.9151 97 38.9349 97 49C97 59.0651 96.4594 67.0849 95.042 73.4626C93.6271 79.8289 91.3519 84.4975 87.9247 87.9247C84.4975 91.3519 79.8289 93.6271 73.4626 95.042C67.0849 96.4594 59.0651 97 49 97C38.9349 97 30.9151 96.4594 24.5374 95.042C18.1711 93.6271 13.5025 91.3519 10.0753 87.9247C6.64806 84.4975 4.37287 79.8289 2.958 73.4626C1.54061 67.0849 1 59.0651 1 49Z",
    stroke: "#FB6F80",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7746 54.8106L52.0942 39.7518C51.4391 38.7125 50.282 38.0918 48.9991 38.0918C47.7162 38.0918 46.5591 38.7125 45.904 39.7518C45.899 39.7598 45.8949 39.7677 45.8899 39.7757L37.2384 54.7868C36.5692 55.848 36.5566 57.1225 37.2039 58.1956C37.8528 59.2694 39.0218 59.91 40.3328 59.91H57.6175C58.9285 59.91 60.1455 59.2694 60.7943 58.1956C61.4417 57.1225 61.4291 55.848 60.7746 54.8106ZM47.5595 45.3139C47.5595 44.529 48.204 43.8929 48.9991 43.8929C49.7942 43.8929 50.4388 44.5291 50.4388 45.3139V50.9977C50.4388 51.7824 49.7942 52.4187 48.9991 52.4187C48.204 52.4187 47.5595 51.7824 47.5595 50.9977V45.3139ZM48.9991 58.1026C47.8083 58.1026 46.8396 57.1465 46.8396 55.9711C46.8396 54.7958 47.8083 53.8397 48.9991 53.8397C50.1899 53.8397 51.1586 54.7958 51.1586 55.9711C51.1586 57.1464 50.1899 58.1026 48.9991 58.1026Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20187_109983",
    transform: "translate(-0.250733) scale(0.00146628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingRed);
export default __webpack_public_path__ + "static/media/ring-red.d209a8f1a4a22dd46cc6cac808ce60c2.svg";
export { ForwardRef as ReactComponent };